<template>
  <!--<PageHeader :title="name">
    <template #status>
      <v-chip :color="!isActive ? 'warning' : undefined">
        {{ isActive ? "Active" : "Inactive" }}
      </v-chip>
      <v-chip v-if="currentPersonRef?.allowSignouts == false" :color="'warning'">
        Admin Hold
      </v-chip>
    </template>
</PageHeader>-->
  <v-container density="compact" dense="true">
    <h1>Welcome {{ name }}!</h1>
    <v-row justify="start" dense>
      <v-col>
        <v-hover v-slot="{ isHovering, props }">
          <RouterLink to="/adult-memberships" class="no-style-link">
            <v-card
              class="ma-2"
              min-width="15vw"
              max-width="344"
              height="40vh"
              v-bind="props"
              :elevation="isHovering ? 16 : 8"
            >
              <v-img
                src="/public-portal/images/AP2.jpg"
                height="65%"
                cover
              ></v-img>
              <v-card-title class="text-h6"
                >Adult Sailing Programs</v-card-title
              >
              <v-card-text class="pt-0">
                Join the community! Our affordable memberships include
                world-class instruction, sailing, windsurfing, paddling, and
                more in the heart of the city.
              </v-card-text>

              <v-overlay
                :model-value="!!isHovering"
                transition="scale-transition"
                class="align-center justify-center"
                scrim="#00507d"
                opacity="30%"
                contained
              >
                <v-btn variant="flat" to="/adult-memberships"
                  >See more info</v-btn
                >
              </v-overlay>
            </v-card>
          </RouterLink>
        </v-hover>
      </v-col>
      <v-col>
        <v-hover v-slot="{ isHovering, props }">
          <RouterLink to="/youth-memberships" class="no-style-link">
            <v-card
              class="ma-2"
              min-width="15vw"
              max-width="344"
              height="40vh"
              v-bind="props"
              :elevation="isHovering ? 16 : 8"
            >
              <v-img
                src="/public-portal/images/IIT2.jpg"
                height="65%"
                cover
              ></v-img>
              <v-card-title class="text-h6"
                >Youth Sailing Programs</v-card-title
              >
              <v-card-text class="pt-0">
                Youth can learn to captain a sailboat in our two-week beginner
                class, while taking advantage of additional programming
                throughout the day.
              </v-card-text>

              <v-overlay
                :model-value="!!isHovering"
                transition="scale-transition"
                class="align-center justify-center"
                scrim="#00507d"
                opacity="30%"
                contained
              >
                <v-btn variant="flat" to="/youth-memberships"
                  >See more info</v-btn
                >
              </v-overlay>
            </v-card>
          </RouterLink>
        </v-hover>
      </v-col>
      <!--
      <v-col>
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            class="ma-2"
            min-width="15vw"
            max-width="344"
            height="40vh"
            v-bind="props"
            :elevation="isHovering ? 16 : 8"
          >
            <v-img
              src="/public-portal/images/UAP5.jpg"
              height="65%"
              cover
            ></v-img>

            <v-card-text class="pt-0">
              <h2 class="text-h6 text-primary">Accessible Sailing Programs</h2>
              UAP!
            </v-card-text>

            <v-overlay
              :model-value="!!isHovering"
              transition="scale-transition"
              class="align-center justify-center"
              scrim="#00507d"
              opacity="30%"
              contained
            >
              <v-btn variant="flat">See more info</v-btn>
            </v-overlay>
          </v-card>
        </v-hover>
      </v-col>-->

      <!--Donations-->
      <v-col>
        <v-hover v-slot="{ isHovering, props }">
          <RouterLink to="/donate" class="no-style-link">
            <v-card
              class="ma-2"
              min-width="15vw"
              max-width="344"
              height="40vh"
              v-bind="props"
              :elevation="isHovering ? 16 : 8"
            >
              <v-img
                src="/public-portal/images/image009.jpg"
                height="65%"
                cover
              ></v-img>
              <v-card-title class="text-h6">Make a Donation</v-card-title>
              <v-card-text class="pt-0">
                Support our mission of Sailing for All! Community Boating, Inc.
                is a public, 501(c)3 non-profit organization operating
                affordable and accessible programs for everyone.
              </v-card-text>

              <v-overlay
                :model-value="!!isHovering"
                transition="scale-transition"
                class="align-center justify-center"
                scrim="#00507d"
                opacity="30%"
                contained
              >
                <v-btn variant="flat" to="/donate">Donation Portal</v-btn>
              </v-overlay>
            </v-card>
          </RouterLink>
        </v-hover>
      </v-col>
      <!--Class Registration-->
      <!--<v-col>
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            class="ma-2"
            min-width="15vw"
            max-width="344"
            height="40vh"
            v-bind="props"
            :elevation="isHovering ? 16 : 8"
          >
            <v-img
              src="/public-portal/images/AP19.jpg"
              height="65%"
              cover
            ></v-img>

            <v-card-text class="pt-0">
              <h2 class="text-h6 text-primary">Register for Classes</h2>
              Learn to sail!
            </v-card-text>

            <v-overlay
              :model-value="!!isHovering"
              transition="scale-transition"
              class="align-center justify-center"
              scrim="#00507d"
              opacity="30%"
              contained
            >
              <v-btn variant="flat" to="/donate">Registration</v-btn>
            </v-overlay>
          </v-card>
        </v-hover>
      </v-col>-->
      <!---->
      <!--<v-col>
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            class="ma-2"
            min-width="15vw"
            max-width="344"
            height="380"
            v-bind="props"
            :elevation="isHovering ? 16 : 8"
          >
            <v-img
              src="/public-portal/images/Sunset compass rose.jpg"
              height="65%"
              cover
            ></v-img>

            <v-card-text class="pt-0">
              <h2 class="text-h6 text-primary">Make a Donation</h2>
              Support our mission of Sailing for All!
            </v-card-text>

            <v-overlay
              :model-value="!!isHovering"
              transition="scale-transition"
              class="align-center justify-center"
              scrim="#00507d"
              opacity="30%"
              contained
            >
              <v-btn variant="flat" to="/donate">Donation Portal</v-btn>
            </v-overlay>
          </v-card>
        </v-hover>
      </v-col>-->
      <!--Event Tickets-->
      <!--<v-col>
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            class="ma-2"
            min-width="15vw"
            max-width="344"
            height="380"
            v-bind="props"
            :elevation="isHovering ? 16 : 8"
          >
            <v-img
              src="/public-portal/images/abow-2023-101.jpg"
              height="65%"
              cover
            ></v-img>

            <v-card-text class="pt-0">
              <h2 class="text-h6 text-primary">Purchase Event Tickets</h2>
              Have a ball - on the dock!
            </v-card-text>

            <v-overlay
              :model-value="!!isHovering"
              transition="scale-transition"
              class="align-center justify-center"
              scrim="#00507d"
              opacity="30%"
              contained
            >
              <v-btn variant="flat" to="/donate">Tickets</v-btn>
            </v-overlay>
          </v-card>
        </v-hover>
      </v-col>-->
      <!--July 4th Tickets
      <v-col v-if="events.july4th.shouldShow">
        <EventbriteLink :event="events.july4th" />
      </v-col>-->
      <!--Summer kickoff
      <v-col v-if="events.summerKickoff.shouldShow">
        <EventbriteLink :event="events.summerKickoff" />
      </v-col>-->
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { useDefaultApi } from "@/autogen";
import PageHeader from "@/components/global/PageHeader.vue";
import { useUser } from "@/composables/useUser";

const { currentPersonRef, currentChildrenRef, loading } = useUser();
const isActive = computed(
  () =>
    !!currentPersonRef.value?.allowSignouts &&
    !!currentPersonRef.value?.activeMembershipTypeName,
);

const name = computed(() => {
  if (loading.value) return "Loading";
  if (!currentPersonRef.value) return "Guest";
  const name = currentPersonRef.value.preferred || currentPersonRef.value.first;
  if (name) return name;
  return "New Member";
});
const hasParentMembership = computed(
  () => !!currentPersonRef.value?.activeMembershipTypeName,
);
const hasChildMembership = computed(() =>
  currentChildrenRef.value.some((a) => !!a.activeMembershipTypeName),
);
const events = computed(() => {
  const shouldShow = hasParentMembership.value || hasChildMembership.value;
  const july4thDiscount = hasChildMembership.value
    ? "JMEM8026491"
    : "AMEM9799065";
  const summerKicoffDiscount = hasChildMembership.value
    ? "JP804758"
    : "AP211444";

  return {
    july4th: {
      shouldShow: shouldShow,
      id: "1981044752182",
      discount: july4thDiscount,
      title: "Purchase July 4th Tickets",
      subtitle: "Reserve your front row seat for the fireworks!",
      imgSrc: "/public-portal/images/sailabration-158.jpg",
    },
    summerKickoff: {
      shouldShow: shouldShow,
      id: "1990568937276",
      discount: summerKicoffDiscount,
      title: "Purchase Summer Kickoff Party Tickets",
      subtitle:
        "Celebrate with drinks, music, games, raffles, and support youth & adaptive sailing.",
      imgSrc: "/public-portal/images/summer-dock-party--3.jpg",
    },
  };
});
</script>

<style></style>
